export enum DataStorageKeyEnum {
  LostPassword = 'lost-password-email',
  Username = 'username',
}
